import 'css-chunksrc/client/scenes/calendarHolidaysCreation/form/styles.scss';export default {
  "form": "_form_1t9gg_1",
  "group": "_group_1t9gg_10",
  "row": "_row_1t9gg_14",
  "horizontalRow": "_horizontalRow_1t9gg_25",
  "label": "_label_1t9gg_31",
  "description": "_description_1t9gg_37",
  "root": "_root_1t9gg_41",
  "listRoot": "_listRoot_1t9gg_45",
  "icon": "_icon_1t9gg_53",
  "input": "_input_1t9gg_62",
  "opened": "_opened_1t9gg_81",
  "list": "_list_1t9gg_45",
  "selected": "_selected_1t9gg_102",
  "option": "_option_1t9gg_106",
  "button": "_button_1t9gg_116"
};